import { LinkClassKey } from '@material-ui/core/Link';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDLinkStyles: Partial<Record<LinkClassKey, CSSProperties>> = {
  root: {
    color: '#212120',
    fontSize: '16px',
  },
};
